import Vue from "vue";
import Vuex from "vuex";

//import axios from "axios";

// @ is an alias to /src
import api from "@/assets/scripts/api.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    baseUrl: process.env.BASE_URL,
    operations: [],
    user: {
      id: "",
      email: "",
      userName: "",
      role: "",
    },
    clients: [],
    airports: [],
    promotions: [],
    notifications: [],
    loading: true,
    errored: false,
  },
  /*computed: mapState({
    operations(state) {
      return state.operations;
    },
  }),*/
  getters: {
    operations: (state) => {
      return state.operations;
    },
    loading: (state) => {
      return state.loading;
    },
    errored: (state) => {
      return state.errored;
    },
    user: (state) => {
      return state.user;
    },
    clients: (state) => {
      return state.clients;
    },
    airports: (state) => {
      return state.airports;
    },
    promotions: (state) => {
      return state.promotions;
    },
    notifications: (state) => {
      return state.notifications;
    },
  },
  mutations: {
    updateOperations(state, operations) {
      state.operations = operations;
    },
    newOperation(state, operation) {
      state.operations.push(operation);
      //state.operations.push(state.operations[0]);
    },
    setUser(state, user) {
      state.user = user;
    },
    changeLoadingState(state, loading) {
      state.loading = loading;
    },
    setErroredState(state, errored) {
      state.errored = errored;
    },
    setClients(state, clients) {
      state.clients = clients;
    },
    setAirports(state, airports) {
      state.airports = airports;
    },
    setPromotions(state, promotions) {
      state.promotions = promotions;
    },
    setNotifications(state, notifications) {
      state.notifications = notifications;
    },
  },
  actions: {
    async signIn({ dispatch }, { vm, userName, password }) {
      try {
        const res = await api.signIn({ userName, password });
        const data = res.data;

        if (data.token) {
          /*await dispatch("setUser", {
            token: data.token,
            id: data.user.id,
            email: data.user.email,
            userName: data.user.userName,
            firstName: data.user.firstName,
            lastName: data.user.lastName,
            role: data.user.role,
          });*/

          await dispatch("setUser", {
            vm: vm,
            token: data.token,
            ...data.user,
          });
          //commit("setUser", { token: data.token, ...data.user });
        } else {
          /*this.$swal({
            icon: "error",
            title: "Oops...",
            text: "Incorrect username or password!",
          });*/
          console.log("error token");
        }

        //vm.$router.go();
        //location.reload();
        return data;
      } catch (error) {
        console.log(error);
      } finally {
        console.log("Fin");
      }
    },
    async setUser(
      { commit, dispatch },
      { vm, token, id, email, userName, firstName, lastName, role }
    ) {
      vm.$cookies.set("token", token);
      vm.$cookies.set("id", id);
      vm.$cookies.set("firstName", firstName);
      vm.$cookies.set("lastName", lastName);
      vm.$cookies.set("email", email);
      vm.$cookies.set("userName", userName);
      vm.$cookies.set("role", role);

      api.setUser(token, id);

      commit("setUser", {
        token,
        id,
        email,
        userName,
        firstName,
        lastName,
        role,
      });

      console.log("getOperations");

      await dispatch("getClients");
      await dispatch("getOperations");
    },
    async getUser({ commit }, counterId) {
      try {
        const res = await api.getUser(counterId);
        return res.data;
      } catch (error) {
        console.log(error);
        commit("setErroredState", true);
      }
    },
    /*async loadItems({ commit, state }) {
      try {
        let response = await axios.get(state.baseUrl + "test.json");
        let operations = response.data.operations;
        for (let i = 0; i < 14; i++) {
          operations[i + 1] = operations[0];
        }
        commit("updateOperations", operations);
        commit("setUser", response.data.user);
        console.log(state.operations);
      } catch (error) {
        console.log(error);
        commit("setErroredState", true);
      } finally {
        commit("changeLoadingState", false);
      }
    },*/
    /*addOperation({ commit }, operation) {
      commit("newOperation", operation);
    },*/
    async getOperations({ commit, dispatch }) {
      try {
        const res = await api.getOperations();
        const data = res.data;
        let [...operations] = data.data;

        //console.log(operations);
        //for (let index = 0; index < operations.length; index++) {
        //for (const [index, element] of operations.entries()) {

        /*if (operations) {
          operations = operations.slice(
            operations.length - 16,
            operations.length
          );
        }*/

        const filledOperations = await Promise.all(
          operations.map(async (operation) => {
            //await operations.forEach(async (element, index) => {
            if (operation.clientId != undefined) {
              try {
                const { ...clientObject } = await dispatch(
                  "getClient",
                  operation.clientId
                );
                operation.clientId = clientObject;
              } catch (error) {
                console.log(error);
                commit("setErroredState", true);
              } /* finally {
              console.log("gotClient in operations");
            }*/
            }
            if (operation.passengerGroup.length > 0) {
              const filledPassengersGroup = await Promise.all(
                operation.passengerGroup.map(async (passenger) => {
                  //operation.passengerGroup.forEach(
                  try {
                    //console.log("try", passengerId);
                    const { ...clientObject } = await dispatch(
                      "getClient",
                      passenger
                    );

                    passenger = {
                      ...clientObject,
                    };
                  } catch (error) {
                    console.log(error);
                    commit("setErroredState", true);
                  } /* finally {
                      console.log("gotClient in operations");
                    }*/
                  return passenger;
                })
              );

              operation.passengerGroup = filledPassengersGroup;
            }
            if (operation.saleId != undefined) {
              try {
                const { ...saleObject } = await dispatch(
                  "getSale",
                  operation.saleId
                );
                operation.saleId = saleObject;
              } catch (error) {
                console.log(error);
                commit("setErroredState", true);
              } /* finally {
                //console.log("gotClient in operations");
                commit("changeLoadingState", false);
              }*/
            }
            //console.log("operation.counterId", operation.counterId);
            if (operation.counterId != undefined) {
              try {
                const { ...counterObject } = await dispatch(
                  "getUser",
                  operation.counterId
                );
                operation.counterId = counterObject;
              } catch (error) {
                console.log(error);
                commit("setErroredState", true);
              }
            }
            return operation;
          })
        );

        //console.log("filledOperations", filledOperations);

        commit("updateOperations", filledOperations);
      } catch (error) {
        console.log(error);
      } finally {
        //console.log("gotOperations");
        commit("changeLoadingState", false);
      }
    },
    async addOperation({ dispatch }, payload) {
      /*const obj = await dispatch("setOperation", { payload, action: "add" });
      return obj;*/

      try {
        const operation = await dispatch("computeOperation", payload);
        try {
          //console.log("saleId", saleId);
          //console.log("OPERATION", operation);

          let res;
          //if (action == "add") {
          res = await api.addOperation(operation);
          //} else {
          //  res = await api.updateOperation(operation);
          //}
          //console.log(res);
          //vm.$router.push("/");
          try {
            await dispatch("getOperations");
            //return data;
          } catch (error) {
            console.log(error);
          } /* finally {
            console.log("gettedOperations");
          }*/
          return res;
        } catch (error) {
          console.log(error);
        } finally {
          console.log("addedOperation");
        }
        // console.log(passengers, operation);
      } catch (error) {
        console.log(error);
      } finally {
        console.log("computeOperation");
      }
    },
    async updateOperation({ dispatch }, payload) {
      try {
        const operation = await dispatch("computeOperation", payload);
        try {
          console.log("operation.total", operation.total);
          const res = await api.updateOperation(operation);
          const data = res.data;
          /*commit;*/
          return data;
        } catch (error) {
          console.log(error);
        }
      } catch (error) {
        console.log(error);
      } finally {
        console.log("computeOperation");
      }
    },
    async deleteOperation({ commit, getters }, payload) {
      try {
        console.log(payload);
        await api.deleteOperation({ id: payload });
        console.log(getters.operations);
        console.log(
          getters.operations.filter((operation) => operation._id !== payload)
        );
        commit(
          "updateOperations",
          getters.operations.filter((operation) => operation._id !== payload)
        );
      } catch (error) {
        console.log(error);
      } finally {
        console.log("operationDeleted");
      }
    },
    async getClient({ commit }, payload) {
      try {
        const res = await api.getClient(payload);
        const data = res.data;
        commit; //
        return data;
      } catch (error) {
        console.log(error);
      } /* finally {
        console.log("gotClient");
      }*/
    },
    async getClients({ commit }) {
      try {
        const res = await api.getClients();
        const data = res.data;
        //commit; //
        //return data;
        console.log(data);
        commit("setClients", data);
      } catch (error) {
        console.log(error);
      } /* finally {
        console.log("gotClient");
      }*/
    },
    async addClient({ commit }, payload) {
      let client = (({
        firstName,
        lastName,
        passengerType,
        documentType,
        documentNumber,
        birthdate,
        phone,
        email,
        address,
        occupation,
        maritalStatus,
      }) => ({
        firstName,
        lastName,
        passengerType,
        documentType:
          documentType == "Pasaporte" ? "passport" : documentType.toLowerCase(),
        documentNumber,
        birthdate,
        phone,
        email,
        address,
        occupation,
        maritalStatus,
      }))(payload);
      try {
        //console.log("CLIENT", client);
        const res = await api.addClient(client);
        const data = res.data;
        commit; //
        return data;
      } catch (error) {
        console.log(error);
      } finally {
        console.log("addedClient");
      }
    },
    async deleteClient(payload) {
      try {
        await api.deleteClient(payload);
      } catch (error) {
        console.log(error);
      } finally {
        console.log("clientDeleted");
      }
    },
    async getSale({ commit }, payload) {
      try {
        const res = await api.getSale(payload);
        const data = res.data;
        commit; //
        return data;
      } catch (error) {
        console.log(error);
      } /* finally {
        console.log("gotSale");
      }*/
    },
    async addSale({ commit, getters }, payload) {
      //console.log("PAYLOAD: ", payload);
      const payments = payload.payments.map((payment) =>
        (({ method, currency, amount, receiptNumber, receiptImage }) => ({
          method,
          currency,
          amount,
          receiptNumber,
          receiptImage,
        }))(payment)
      );

      //console.log("PAYMENTS: ", payments);

      const sale = (({
        it,
        paymentReceiptNumber,
        saleDate,
        saleDescription,
        counterReportDate,
        formNumber,
        //ticketNumber,
        operator,
      }) => ({
        it,
        paymentReceiptNumber,
        saleDate: new Date(saleDate).toISOString(),
        saleDescription,
        paymentMethods: payments,
        counterReportDate: new Date(counterReportDate).toISOString(),
        formNumber,
        //ticketNumber,
        operator,
        counterId: getters.user.id,
      }))(payload);
      //console.log("sale", sale);
      try {
        //console.log("SALE", sale);
        const res = await api.addSale(sale);
        //console.log("res", res);
        const data = res.data;
        commit;
        return data;
      } catch (error) {
        console.log(error);
      } finally {
        console.log("addedSale");
      }
    },
    async getPromotions({ commit }) {
      try {
        const res = await api.getPromotions();
        const data = res.data;
        commit("setPromotions", data);
        return data;
      } catch (error) {
        console.log(error);
      } /* finally {
        console.log("gotPromotions");
      }*/
    },
    async addPromotion({ commit }, payload) {
      let promotion = (({
        message,
        airlineCode,
        destinations,
        startDate,
        endDate,
        file,
        currency,
        total,
      }) => ({
        message,
        airlineCode,
        routeGroup: destinations.map((destination) => {
          return {
            ICAO: destination.ICAO,
            datetime: new Date(
              destination.date + "T" + destination.time + "Z"
            ).toISOString(),
          };
        }),
        startDate,
        endDate,
        file,
        currency,
        total,
      }))(payload);
      try {
        const res = await api.addPromotion(promotion);
        const data = res.data;
        commit; //
        return data;
      } catch (error) {
        console.log(error);
      } finally {
        console.log("addedPromotion");
      }
    },
    async getNotifications({ commit }) {
      try {
        const res = await api.getNotifications();
        const data = res.data;
        commit("setNotifications", data);
        return data;
      } catch (error) {
        console.log(error);
      } /* finally {
        console.log("gotNotifications");
      }*/
    },
    async addNotification({ commit }, payload) {
      let notification = (({
        message,
        sytle,
        startDate,
        endDate,
        file,
        link,
      }) => ({ message, sytle, startDate, endDate, file, link }))(payload);
      try {
        const res = await api.addNotification(notification);
        const data = res.data;
        commit; //
        return data;
      } catch (error) {
        console.log(error);
      } finally {
        console.log("addedNotification");
      }
    },
    /*async setOperation({ dispatch }, obj) {
      const payload = obj.payload;
      const action = obj.action;

    },*/
    async computeOperation({ dispatch, getters }, payload) {
      let passengers = [];
      let saleId;

      console.log(payload);

      // Add main client as client
      if (payload.clientId == "") {
        try {
          const res = await dispatch("addClient", payload);
          payload.clientId = res.data;
          //return data;
        } catch (error) {
          console.log(error);
        } finally {
          console.log("addClient");
        }
      }
      // Add passengers as clients
      for (let i = 0; i < payload.passengers.length; i++) {
        if (payload.isClientPassanger.length > 0 && i == 0) {
          passengers.push(payload.clientId);
        } else {
          try {
            const res = await dispatch("addClient", payload.passengers[i]);
            //const clienteId = res.data;
            passengers.push(res.data);
            //return data;
          } catch (error) {
            console.log(error);
          } finally {
            console.log("addedOperation");
          }
        }
      }
      // Add sale if exist
      if (payload.hasSale.length === 1) {
        try {
          const res = await dispatch("addSale", payload);
          saleId = res.data;
        } catch (error) {
          console.log(error);
          //commit("setErroredState", true);
        } finally {
          console.log("gotSale in operations");
          //commit("changeLoadingState", false);
        }
      }

      let operation = (({
        //reservationNumber,
        id,
        clientId,
        airlineCode,
        destinations,
        currency,
        fee,
        total,
      }) => ({
        id,
        clientId,
        saleId,
        //reservationNumber,
        airlineCode,
        routeGroup: destinations.map((destination) => {
          return {
            ICAO: destination.ICAO,
            datetime: new Date(
              destination.date + "T" + destination.time + "Z"
            ).toISOString(),
          };
        }),
        passengerGroup: passengers,
        currency,
        fee,
        total: parseFloat(total),
        counterId: getters.user.id,
      }))(payload);

      return operation;
    },
    setAirports({ commit }, airports) {
      commit("setAirports", airports);
    },
  },
  modules: {},
});
